module.exports = __webpack_public_path__ + "img/icon-question-rating-gray.e2f4228f.svg";